/*
 *
 * CommunicationDetailMobile constants
 *
 */

export const FLUSH_STATE = 'app/CommunicationDetailMobile/FLUSH_STATE';

export const LOAD_COMMUNICATION =
  'app/CommunicationDetailMobile/LOAD_COMMUNICATION';
export const LOAD_COMMUNICATION_SUCCESS =
  'app/CommunicationDetailMobile/LOAD_COMMUNICATION_SUCCESS';
export const LOAD_COMMUNICATION_ERROR =
  'app/CommunicationDetailMobile/LOAD_COMMUNICATION_ERROR';

export const UPDATE_COMMUNICATION =
  'app/CommunicationDetailMobile/UPDATE_COMMUNICATION';
export const UPDATE_COMMUNICATION_SUCCESS =
  'app/CommunicationDetailMobile/UPDATE_COMMUNICATION_SUCCESS';
export const UPDATE_COMMUNICATION_ERROR =
  'app/CommunicationDetailMobile/UPDATE_COMMUNICATION_ERROR';
